import { LucideIcon } from 'lucide-react';

import { cn } from '@crossnokaye/ux-common';

import { withTooltip } from '@/ux-common/components/tooltip/with-tooltip';

interface IconWrapperProps {
  icon: LucideIcon;
  isDisabled: boolean;
  onClick?: () => void;
}

/**
 * Wrapper component that handles hover/active coloring for icons in sequencer table.
 * Shows pointer cursor and primary color on hover when not disabled.
 */
export const IconWrapper = ({ icon: Icon, isDisabled, onClick, ...props }: IconWrapperProps) => {
  return (
    <Icon
      {...props}
      className={cn('glyph glyph-sm', !isDisabled && 'hover:text-primary hover:cursor-pointer')}
      onClick={onClick}
    />
  );
};

export const IconWithTooltip = withTooltip(IconWrapper);
